export const SUPPORT_EMAIL = "ask@iro-hana.com";
export const SUPPORT_PHONE = "050-1725-1297";

export const DESCRIPTION_LINES = [
  "ログインするには事前に組織IDの入力が必要です。",
  "組織IDは「A12-3456-7890」のような形式で割り振られております。",
  "もし組織IDが分からない場合は、登録時の案内メールをご確認いただくか、お問い合わせ窓口までご相談ください。",
  `【カスタマーサポート】${SUPPORT_PHONE}　${SUPPORT_EMAIL}`,
];

export const LOGIN_FORM_KEY = "login-form";
export const LOGIN_CACHED_EMAIL = "login-email-cached"; //key|value={map{externalId, email}}
export const LOGIN_CACHED_EXTERNAL_ID = "login-external-id-cached"; // key|value=externalId

export const CODE_QUERY_KEY = "code";
export const REDIRECT_URL_QUERY_KEY = "redirectUrl";
export const CLIENT_ID_QUERY_KEY = "clientId";
export const PRODUCT_CODE_QUERY_KEY = "productCode";
export const STATE_QUERY_KEY = "state";

export const RESOURCE_VALUES = ["rso", "company"] as const;
export type TResource = (typeof RESOURCE_VALUES)[number];
export const DEFAULT_RESOURCE: TResource = "rso";

export const isResource = (value: unknown): value is TResource => typeof value === "string" && (RESOURCE_VALUES as readonly string[]).includes(value);

export const normalizeResource = (value: unknown): TResource => (isResource(value) ? value : DEFAULT_RESOURCE);
